import{jsx as t}from"react/jsx-runtime";import{createContext as o}from"react";const n=o(null),a=({messagingClient:e,children:r})=>t(n.Provider,{value:e,children:r});export{n as MessagingClientContext,a as MessagingProvider};
//# sourceMappingURL=MessagingProvider.es.js.map
